
const BASIC_CONST = {

  /**
   * Espacio para las constantes de los status
   */
  STATUS_BASIC_ACTIVE: 1,
  STATUS_BASIC_INACTIVE: 0,

  STATUS_USER_BLOCKED: 3,
  STATUS_USER_ACTIVE: 1,
  STATUS_USER_INACTIVE: 0,

  /**
   * Estatus para las constantes de los roles
   */
  ROLE_ADMIN: 'ADMIN',
  ROLE_CLUB_STAFF: 'CLUB_STAFF',
  ROLE_PARENT: 'PARENT',
  ROLE_ATHLETE: 'ATHLETE',
  ROLE_STF_STAFF: 'STF_STAFF',
  ROLE_SCOUT: 'SCOUT',

  /**
   * Constantes para las opciones de los modales
   */

  OPTION_MODAL_CLOSE: 1,
  OPTION_MODAL_YES: 2,
  OPTION_MODAL_NO: 3,

  /**
   * Constantes para variables de localstorage
   */

  LOCALSTORAGE_TOKEN: 'token',
  LOCALSTORAGE_USER: 'user',
  LOCALSTORAGE_EMAIL: 'email',
  LOCALSTORAGE_THEME: 'theme',
  LOCALSTORAGE_LANGUAGE: 'language',
  LOCALSTORAGE_INFOSIGNUP: 'infoSignUp',
  LOCALSTORAGE_ERROR_LOGIN: 'error_login',
  LOCALSTORAGE_SHOW_PROFILE_COMPLETED: 'show_profile_completed',
  LOCALSTORAGE_REMEMBER_ME: 'rmb',
  LOCALSTORAGE_INFO_NEW_ATHLETE: 'infoNewAthlete',
  LOCALSTORAGE_INFO_ATHLETA_VALUATION_ENTRY: 'infoAthleteValuationEntry',
  LOCALSTORAGE_SWITCH_FLAG: 'switchFlag',
  LOCALSTORAGE_USER_ROLES: 'userRoles',


  PROFILE_STEP_COMPLETE: 0,
  PROFILE_STEP_CLUB_STAFF_PROFILE_PHOTO: 1,
  PROFILE_STEP_CLUB_STAFF_IDENTIFICATION_DOCUMENTO_PHOTO: 2,
  PROFILE_STEP_CLUB_STAFF_DESCRIBE_YOURSELF: 3,
  PROFILE_STEP_CLUB_STAFF_CLUB_DATA: 4,
  PROFILE_STEP_CLUB_STAFF_CLUB_LOGO: 5,
  PROFILE_STEP_CLUB_STAFF_CREATE_TEAM: 6,

  PROFILE_STEP_PARENT_PROFILE_PHOTO: 1,
  PROFILE_STEP_PARENT_IDENTIFICATION_DOCUMENTO_PHOTO: 2,
  PROFILE_STEP_PARENT_MEMBERSHIP: 3,
  PROFILE_STEP_PARENT_REGISTER_ATHLETE: 4,
  PROFILE_STEP_PARENT_BIRTH_CERTIFICATE_ATHLETE: 5,
  PROFILE_STEP_PARENT_PROFILE_PHOTO_ATHLETE: 6,
  PROFILE_STEP_PARENT_IDENTIFICATION_DOCUMENTO_PHOTO_ATHLETE: 7,
  PROFILE_STEP_PARENT_BIOLOGICAL_INFO_ATHLETE: 8,
  PROFILE_STEP_PARENT_CLUB_PRESELECTION_ATHLETE: 9,

  PROFILE_STEP_ATHLETE_PROFILE_PHOTO: 1,
  PROFILE_STEP_ATHLETE_IDENTIFICATION_DOCUMENTO_PHOTO: 2,
  PROFILE_STEP_ATHLETE_BIOLOGICAL_INFO: 3,
  PROFILE_STEP_ATHLETE_CLUB_PRESELECTION: 4,

  PROFILE_STEP_SCOUT_ORG_DESCRIPTION: 3,

  REGEX_PASSWORD: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,72}$/,  // /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*.-]).{8,16}$/,
  REGEX_EMAIL: "^[a-zA-Z0-9._%+-]+[a-zA-Z0-9]@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",  // /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*.-]).{8,16}$/,

  CRYPTO_SECRET_KEY: 'HY5aaysd8AVJCqj',
  CRYPTO_VALIDATOR: 'hKVFA4Wy8mShs9M'
}
/** CONFIGURACION DE CONSTANTES */
export const CONST = {

  DECIMAL: 'decimal',
  BOOLEAN: 'boolean',
  TIME: 'time',
  URL: 'url',
  UNITS : ['decimal', 'boolean', 'time', 'url']
,
  STATUS: {
    BASIC: {
      active: BASIC_CONST.STATUS_BASIC_ACTIVE,
      inactive: BASIC_CONST.STATUS_BASIC_INACTIVE,
    },

    USER: {
      blocked: BASIC_CONST.STATUS_USER_BLOCKED,
      active: BASIC_CONST.STATUS_USER_ACTIVE,
      inactive: BASIC_CONST.STATUS_USER_INACTIVE,
    }
  },

  ROLES: {
    admin: BASIC_CONST.ROLE_ADMIN,
    club_staff: BASIC_CONST.ROLE_CLUB_STAFF,
    parent: BASIC_CONST.ROLE_PARENT,
    athlete: BASIC_CONST.ROLE_ATHLETE,
    stf_staff: BASIC_CONST.ROLE_STF_STAFF,
    scout: BASIC_CONST.ROLE_SCOUT
  },

  OPTION_MODAL: {
    close: BASIC_CONST.OPTION_MODAL_CLOSE,
    yes: BASIC_CONST.OPTION_MODAL_YES,
    no: BASIC_CONST.OPTION_MODAL_NO,
  },

  PROFILE_STEP: {

    CLUB_STAFF: {
      profilePhoto: BASIC_CONST.PROFILE_STEP_CLUB_STAFF_PROFILE_PHOTO,
      idDocumentPhoto: BASIC_CONST.PROFILE_STEP_CLUB_STAFF_IDENTIFICATION_DOCUMENTO_PHOTO,
      describeYourself: BASIC_CONST.PROFILE_STEP_CLUB_STAFF_DESCRIBE_YOURSELF,
      clubData: BASIC_CONST.PROFILE_STEP_CLUB_STAFF_CLUB_DATA,
      clubLogo: BASIC_CONST.PROFILE_STEP_CLUB_STAFF_CLUB_LOGO,
      createTeam: BASIC_CONST.PROFILE_STEP_CLUB_STAFF_CREATE_TEAM,
    },

    PARENT: {
      profilePhoto: BASIC_CONST.PROFILE_STEP_PARENT_PROFILE_PHOTO,
      idDocumentPhoto: BASIC_CONST.PROFILE_STEP_PARENT_IDENTIFICATION_DOCUMENTO_PHOTO,
      membership: BASIC_CONST.PROFILE_STEP_PARENT_MEMBERSHIP,
      registerAthlete: BASIC_CONST.PROFILE_STEP_PARENT_REGISTER_ATHLETE,
      birthCertificateAthlete: BASIC_CONST.PROFILE_STEP_PARENT_BIRTH_CERTIFICATE_ATHLETE,
      profilePhotoAthlete: BASIC_CONST.PROFILE_STEP_PARENT_PROFILE_PHOTO_ATHLETE,
      idDocumentPhotoAthlete: BASIC_CONST.PROFILE_STEP_PARENT_IDENTIFICATION_DOCUMENTO_PHOTO_ATHLETE,
      biologicalInfoAthlete: BASIC_CONST.PROFILE_STEP_PARENT_BIOLOGICAL_INFO_ATHLETE,
      clubPreselectionAthlete: BASIC_CONST.PROFILE_STEP_PARENT_CLUB_PRESELECTION_ATHLETE
    },

    ATHLETE: {
      profilePhoto: BASIC_CONST.PROFILE_STEP_ATHLETE_PROFILE_PHOTO,
      idDocumentPhoto: BASIC_CONST.PROFILE_STEP_ATHLETE_IDENTIFICATION_DOCUMENTO_PHOTO,
      biologicalInfo: BASIC_CONST.PROFILE_STEP_ATHLETE_BIOLOGICAL_INFO,
      clubPreselection: BASIC_CONST.PROFILE_STEP_ATHLETE_CLUB_PRESELECTION,
    },

    SCOUT: {
      profilePhoto: BASIC_CONST.PROFILE_STEP_ATHLETE_PROFILE_PHOTO,
      idDocumentPhoto: BASIC_CONST.PROFILE_STEP_ATHLETE_IDENTIFICATION_DOCUMENTO_PHOTO,
      orgDescription: BASIC_CONST.PROFILE_STEP_SCOUT_ORG_DESCRIPTION
    },

    STF: {
      profilePhoto: BASIC_CONST.PROFILE_STEP_ATHLETE_PROFILE_PHOTO,
      idDocumentPhoto: BASIC_CONST.PROFILE_STEP_ATHLETE_IDENTIFICATION_DOCUMENTO_PHOTO
    },
    complete: BASIC_CONST.PROFILE_STEP_COMPLETE

  },

  LOCALSTORAGE: {
    token: BASIC_CONST.LOCALSTORAGE_TOKEN,
    user: BASIC_CONST.LOCALSTORAGE_USER,
    email: BASIC_CONST.LOCALSTORAGE_EMAIL,
    theme: BASIC_CONST.LOCALSTORAGE_THEME,
    language: BASIC_CONST.LOCALSTORAGE_LANGUAGE,
    infoSignUp: BASIC_CONST.LOCALSTORAGE_INFOSIGNUP,
    errorLogin: BASIC_CONST.LOCALSTORAGE_ERROR_LOGIN,
    showProfileCompleted: BASIC_CONST.LOCALSTORAGE_SHOW_PROFILE_COMPLETED,
    rememberMe: BASIC_CONST.LOCALSTORAGE_REMEMBER_ME,
    infoNewAthlete: BASIC_CONST.LOCALSTORAGE_INFO_NEW_ATHLETE,
    infoAthleteValuationEntry: BASIC_CONST.LOCALSTORAGE_INFO_ATHLETA_VALUATION_ENTRY,
    switchFlag: BASIC_CONST.LOCALSTORAGE_SWITCH_FLAG,
    userRoles: BASIC_CONST.LOCALSTORAGE_USER_ROLES,
  },

  REGEX: {
    password: BASIC_CONST.REGEX_PASSWORD,
    email: BASIC_CONST.REGEX_EMAIL
  },

  CRYPTO: {
    secretKey: BASIC_CONST.CRYPTO_SECRET_KEY,
    validator: BASIC_CONST.CRYPTO_VALIDATOR
  }
};
